import { render, staticRenderFns } from "./Programme.vue?vue&type=template&id=3684466c&scoped=true&"
import script from "./Programme.vue?vue&type=script&lang=js&"
export * from "./Programme.vue?vue&type=script&lang=js&"
import style0 from "./Programme.vue?vue&type=style&index=0&id=3684466c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684466c",
  null
  
)

export default component.exports